import { GetProjectResponse } from "../common/commonDomain";
import { CompanyInfo } from "../../types/CompanyInfo";
import { ProjectController } from "./projectDomain";
import { AxiosInstance } from "axios";
import { GetShareholdersResponse, prepShareholderData } from "../../types/Shareholder";
import { FileUploadConfig } from "../../fileUpload/fileUploadDomain";
import { History } from "history";
import { AccessType } from "../../types/enums/AccessType";
import { User, UserCompany } from "../../types/UserInfo";
import { ProductSubscriptionResponse } from "../../payment/Payment";
import { AIClient } from "../../ai/AIAssistant";
import { EventDispatcher } from "../../events/eventsDomain";
import { RootStoreData } from "../../events/rootStoreData";

export function loadProject(
  http: AxiosInstance,
  history: History,
  user: User,
  companyInfo: CompanyInfo,
  projectId: string,
  accessType: AccessType,
  dispatch: EventDispatcher,
  rootStoreData: RootStoreData,
  companies: UserCompany[],
) {
  const orgNo = companyInfo.company.organizationnumber;

  return Promise.all([
    http.get<GetProjectResponse>(`/project/${projectId}`),
    http.get<GetShareholdersResponse>(`/shareholder/all/${orgNo}`),
    http.get<ProductSubscriptionResponse>(`/payment/find-subscription/${orgNo}`),
    http.get<FileUploadConfig>(`/archive/${orgNo}/file-upload-config`),
  ]).then(
    ([projectResponse, shareholdersResponse, subscriptionResponse, fileUploadConfigResponse]) => {
      const currentSubscription = subscriptionResponse.data?.paidSubscription;
      return new ProjectController(
        projectResponse.data,
        {
          user,
          companyInfo,
          shareholderData: prepShareholderData(orgNo, shareholdersResponse.data),
          currentSubscription,
          fileUploadConfig: fileUploadConfigResponse.data,
          aiClient: new AIClient(http, orgNo),
          rootDispatch: dispatch,
          rootStoreData,
          companies: companies.map((c) => ({ orgNo: c.organisationNumber, name: c.name })),
        },
        http,
        history,
        accessType,
      );
    },
  );
}
